import { render } from "./ColloqueDetails.vue?vue&type=template&id=10b2e8ae&scoped=true&ts=true"
import script from "./ColloqueDetails.vue?vue&type=script&lang=ts"
export * from "./ColloqueDetails.vue?vue&type=script&lang=ts"

import "./ColloqueDetails.vue?vue&type=style&index=0&id=10b2e8ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b2e8ae"]])

export default __exports__